/* Each complete light or strip run occupies one output on one driver. */
window.LighteezKitPlanner = {
  recommend(runs, drivers, factor = 1) {
    if(!runs.length||runs.some(r=>!r.valid||!Number.isInteger(r.qty)||r.qty<1||r.qty>99||!Number.isFinite(r.watts)||r.watts<=0||r.watts>72.000001))return null;
    const types=drivers.filter(d=>d.watts>0&&d.ports>0&&Number.isFinite(d.price)&&d.price>=0);
    if(!types.length)return null;
    const count=runs.reduce((n,r)=>n+r.qty,0),watts=runs.reduce((n,r)=>n+r.watts*r.qty,0),candidates=[];
    const maxGroups=Math.min(count,20);
    const enumerate=(chosen,start,cost,capacity,ports)=>{
      if(chosen.length&&capacity+.000001>=watts&&ports>=count)candidates.push({chosen:[...chosen],cost});
      if(chosen.length===maxGroups)return;
      for(let i=start;i<types.length;i++){chosen.push(types[i]);enumerate(chosen,i,cost+types[i].price,capacity+types[i].watts*factor,ports+types[i].ports);chosen.pop();}
    };
    enumerate([],0,0,0,0);
    candidates.sort((a,b)=>a.cost-b.cost||a.chosen.length-b.chosen.length);
    for(const candidate of candidates.slice(0,200)){
      const groups=candidate.chosen.map((d,i)=>({id:i+1,watts:Math.round(d.watts*factor*1000)/1000,ports:d.ports,driverId:d.id}));
      const allocation=this.distribute(runs,groups);
      if(allocation)return {groups,allocation,cost:candidate.cost};
    }
    return null;
  },
  evaluate(runs, groups) {
    const loads=groups.map(g=>({...g,load:0,used:0}));
    let valid=runs.length>0;
    for(const run of runs){
      const group=loads.find(g=>g.id===run.group);
      if(!group||!run.valid||!Number.isFinite(run.watts)||run.watts<=0||run.watts>72.000001||!Number.isInteger(run.qty)||run.qty<1||run.qty>99)valid=false;
      if(group){group.load+=run.watts*run.qty;group.used+=run.qty;}
    }
    for(const g of loads){g.load=Math.round(g.load*1000)/1000;g.fits=g.watts>0&&g.used>0&&g.load<=g.watts+.000001&&g.used<=g.ports;}
    return {loads,fits:valid&&loads.length>0&&loads.every(g=>g.fits)};
  },
  distribute(runs, groups) {
    if(!runs.length||!groups.length||groups.some(g=>!g.watts||!g.ports)||runs.some(r=>!r.valid||!Number.isFinite(r.watts)||r.watts<=0||r.watts>72.000001||!Number.isInteger(r.qty)||r.qty<1||r.qty>99))return null;
    const units=runs.flatMap(r=>Array.from({length:r.qty},()=>({runId:r.id,watts:Math.round(r.watts*1000)}))).sort((a,b)=>b.watts-a.watts);
    const bins=groups.map(g=>({id:g.id,capacity:Math.round(g.watts*1000),ports:g.ports,load:0,used:0}));
    if(units.length<bins.length||units.length>bins.reduce((n,g)=>n+g.ports,0)||units.reduce((n,u)=>n+u.watts,0)>bins.reduce((n,g)=>n+g.capacity,0))return null;
    const assigned=[];
    const candidates=u=>bins.map((g,i)=>({g,i})).filter(({g})=>g.load+u.watts<=g.capacity&&g.used<g.ports).sort((a,b)=>a.g.load/a.g.capacity-b.g.load/b.g.capacity||a.g.used-b.g.used);
    // Try a balanced placement first; use a bounded search if packing is awkward.
    let greedy=true;
    for(const u of units){const next=candidates(u)[0];if(!next){greedy=false;break;}next.g.load+=u.watts;next.g.used++;assigned.push(next.i);}
    if(!greedy||bins.some(g=>!g.used)){
      if(units.length>150)return null;
      bins.forEach(g=>{g.load=0;g.used=0;});assigned.length=0;let budget=30000;
      const search=index=>{
        if(--budget<0)return false;
        if(index===units.length)return bins.every(g=>g.used>0);
        const seen=new Set(),u=units[index];
        for(const {g,i} of candidates(u)){
          const state=[g.capacity,g.ports,g.load,g.used].join(':');if(seen.has(state))continue;seen.add(state);
          g.load+=u.watts;g.used++;assigned[index]=i;
          if(search(index+1))return true;
          g.load-=u.watts;g.used--;
        }
        return false;
      };
      if(!search(0))return null;
    }
    const allocation=new Map();units.forEach((u,i)=>{const group=bins[assigned[i]].id,key=u.runId+':'+group;const row=allocation.get(key)||{runId:u.runId,group,qty:0};row.qty++;allocation.set(key,row);});
    return [...allocation.values()];
  }
};
